import React  from "react";
import $ from "jquery";
import { Link } from "react-scroll";
import { NavLink } from "react-router-dom";
export default function Sidebar() {

    $(document).ready(function(){
        $(".menu_icon").click(function(){
          $(".sidebar").addClass("menu_show");
        });
      });
      $(document).ready(function(){
        $(".close_icon").click(function(){
          $(".sidebar").removeClass("menu_show");
        });
      });

  return (
    <>
    <div className="sidebar">
         <div className="close_icon">
        <i class="fas fa-times"></i>
        </div>
      <div className="sidebar_logo">
       <NavLink to="/" >
      <img
      src={require("../assets/images/platinum/logo.png")}
      className="img-fluid"
        alt="Icon"
        />
        </NavLink>
        </div>
       <ul>
        <li><Link to="home"  spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >Home</Link></li>
        <li><Link to="features"  spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >Features</Link></li>
        <li><Link to="token" spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >Token Sale</Link></li>
        <li> <Link to="roadmap" spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >Roadmap</Link></li>
        <li> <Link to="stacking" spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >STAKING</Link></li>
        <li> <Link to="#" spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >SWAP</Link></li>
        <li><Link to="faq" spy={true} smooth={true} duration={250} color="transparent" className="nav-link" >FAQ</Link></li>
       </ul>
      <button className="primary_btn">CONNECT WALLET</button>
      <div class="dropdown">
                <button class="primary_btn dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                  Dropdown link
                </button>
              
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li><p>balance:</p> <p class="dropdown-item" >0.000</p></li>
                <li><a class="dropdown-item" href="/Staking">Stake</a></li>
                  <li><a class="dropdown-item" href="/">Log out</a></li>
                </ul>
              </div>
      </div>
    </>
  );
}
